/* eslint-disable import/prefer-default-export */
import { createNavigation } from '../lib/utils'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const OrganizationNavigation = createNavigation([
  {
    name: 'organization',
    path: '/[organizationSlug]',
    subroutes: [
      {
        name: 'assets',
        path: '/assets',
        subroutes: [
          {
            name: 'asset',
            path: '/[assetId]',
          },
          {
            name: 'brand',
            path: '/brand',
            subroutes: [
              {
                name: 'asset',
                path: '/[assetId]',
              },
            ],
          },
        ],
      },
      {
        name: 'billing',
        path: '/billing',
        subroutes: [
          {
            name: 'thanks',
            path: '/thanks',
          },
          {
            name: 'upgrade',
            path: '/upgrade',
          },
        ],
      },
      {
        name: 'charGTM',
        path: '/chat',
      },
      {
        name: 'checklist',
        path: '/checklist',
      },
      {
        name: 'companies',
        path: '/companies',
        subroutes: [
          {
            name: 'company',
            path: '/[companyId]',
            subroutes: [
              {
                name: 'reviews',
                path: '/reviews',
              },
              {
                name: 'seo',
                path: '/seo',
              },
              {
                name: 'features',
                path: '/features',
              },
            ],
          },
        ],
      },
      {
        name: 'insights',
        path: '/insights',
        subroutes: [
          {
            name: 'insight',
            path: '/[insightId]',
          },
          {
            name: 'trends',
            path: '/trends',
          },
          {
            name: 'rawInsights',
            path: '/raw-insights',
          },
          {
            name: 'generatedItems',
            path: '/generated-items',
            subroutes: [
              {
                name: 'generatedItem',
                path: '/[itemId]',
              },
            ],
          },
          {
            name: 'trendItems',
            path: '/trend-items',
            subroutes: [
              {
                name: 'trendItem',
                path: '/[itemId]',
              },
            ],
          },
        ],
      },
      {
        name: 'launches',
        path: '/launches',
        subroutes: [
          {
            name: 'launch',
            path: '/[launchId]',
          },
        ],
      },
      {
        name: 'news',
        path: '/news',
      },
      {
        name: 'personas',
        path: '/personas',
        subroutes: [
          {
            name: 'persona',
            path: '/[personaId]',
          },
        ],
      },
      {
        name: 'accounts',
        path: '/accounts',
        subroutes: [
          {
            name: 'account',
            path: '/[accountId]',
          },
        ],
      },
      {
        name: 'contacts',
        path: '/contacts',
        subroutes: [
          {
            name: 'contact',
            path: '/[contactId]',
          },
        ],
      },
      {
        name: 'deals',
        path: '/deals',
        subroutes: [
          {
            name: 'deal',
            path: '/[dealId]',
          },
        ],
      },
      {
        name: 'productIdeas',
        path: '/product-ideas',
        subroutes: [
          {
            name: 'productIdea',
            path: '/[productIdeaId]',
          },
        ],
      },
      {
        name: 'productOKRs',
        path: '/product-okrs',
      },
      {
        name: 'releaseNotes',
        path: '/release-notes',
      },
      {
        name: 'research',
        path: '/research',
      },
      {
        name: 'roadmap',
        path: '/roadmap',
        subroutes: [
          {
            name: 'roadmapItem',
            path: '/[roadmapItemId]',
          },
          {
            name: 'tasks',
            path: '/tasks',
          },
        ],
      },
      {
        name: 'settings',
        path: '/settings',
        subroutes: [],
      },
      {
        name: 'subscribers',
        path: '/subscribers',
      },
      {
        name: 'survey',
        path: '/survey',
      },
      {
        name: 'tasks',
        path: '/tasks',
        subroutes: [
          {
            name: 'task',
            path: '/[taskId]',
          },
        ],
      },
      {
        name: 'testimonials',
        path: '/testimonials',
      },
      {
        name: 'winLoss',
        path: '/win-loss',
      },
      {
        name: 'calendar',
        path: '/calendar',
      },
      {
        name: 'measurements',
        path: '/measurements',
      },
      {
        name: 'missionControlPM',
        path: '/mission-control-pm',
      },
      {
        name: 'missionControl',
        path: '/mission-control',
      },
      {
        name: 'timeline',
        path: '/timeline',
      },
      {
        name: 'messagingLibrary',
        path: '/messaging-library',
      },
    ],
  },
] as const)
